export const apiConstants = {
  url: "/api/frontend",
};
